import { type RefObject, useEffect, useState } from 'react';

type ReturnObject = {
  isStuck: boolean;
  top: string; // Top value to give to the position sticky element
};

// Hook for keeping track of when a position sticky element becomes sticky
export const useIsStuck = (ref: RefObject<HTMLDivElement>): ReturnObject => {
  const [isStuck, setIsStuck] = useState<boolean>(false);

  useEffect(() => {
    const cachedNavElement = ref.current;

    if (!cachedNavElement) return;

    const observer = new IntersectionObserver(
      // Ratio is only less than 100% when sticky because of top -1px
      ([entry]) => setIsStuck(entry.intersectionRatio < 1),
      // Events for when nav starts and stops being 100% visible
      { threshold: [1] }
    );
    observer.observe(cachedNavElement);

    return () => observer.disconnect();
  }, [ref]);

  return { isStuck, top: '-1px' };
};
